import { BaseEntityModel } from '../core/abstractions/base-entity.model';

export class FailedRequestModel extends BaseEntityModel {
    clientId: string;
    url: string;
    method: string;
    body: string;

    constructor(init: Partial<FailedRequestModel>) {
        super();
        Object.assign(this, init);
    }
}
